import { YammerState } from '../../state/types';

type GetCurrentAnnouncement = (state: YammerState) => string | undefined;
export const getCurrentAnnouncement: GetCurrentAnnouncement = (state) => state.announcements.current;
